import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { getUserInfo } from '../../Config/Auth';

import Sidebar from '../Components/Sidebar/Sidebar';
import Navbar from '../Components/Navbar/Navbar';

import Profile from '../Components/Profile/Profile';
import Dashboard from '../Pages/Dashboard/Dashboard';
import Jobs from '../Pages/Jobs/Jobs';
import Invoices from '../Pages/Invoices/Invoices';
import Notes from '../Pages/Notes/Notes';
import Drivers from '../Pages/Drivers/Drivers';
import SiteUsers from '../Pages/SiteUsers/SiteUsers';
import Notifications from '../Pages/Notifications/Notifications';
import Settings from '../Pages/Settings/Settings';
import WorkInProgress from "../../../../Pages/WorkInProgress/WorkInProgress"

import ProtectedRoute from './ProtectedRoute';
import JobBoard from '../Pages/JobBoard/Jobs';
import Trucks from '../Pages/Trucks/Trucks';

const TCRoutes = () => {
  const location = useLocation();
  const user = getUserInfo();
  const isInitialActivated = user?.initialActivated ?? true;

  const shouldRedirect = !isInitialActivated && location.pathname !== '/tc/dashboard';

  return (
    <div className="app">
      <Sidebar />
      <div className="main-content">
        <Navbar />
        {shouldRedirect ? (
          <Navigate to="/tc/dashboard" replace />
        ) : (
          <Routes>
            <Route path="/profile" element={<ProtectedRoute>  <Profile /> </ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute requiredPermission={{ section: 'dashboard', keys: ['dashboard_view'] }}> <Dashboard /> </ProtectedRoute>} />
            <Route path="/jobboard" element={<ProtectedRoute requiredPermission={{ section: 'job board', keys: ['jobboard_view','jobboard_edit'] }}> <JobBoard /> </ProtectedRoute>} />
            <Route path="/myjobs" element={<ProtectedRoute requiredPermission={{ section: 'my jobs', keys: ['myjobs_view','myjobs_edit'] }}> <Jobs /> </ProtectedRoute>} />            
            <Route path="/invoices" element={<ProtectedRoute requiredPermission={{ section: 'invoices', keys: ['invoices_view'] }}> <Invoices /> </ProtectedRoute>} />
            <Route path="/drivers" element={<ProtectedRoute requiredPermission={{ section: 'drivers', keys: ['drivers_view','drivers_edit'] }}>  <Drivers /> </ProtectedRoute>} />
            <Route path="/trucks" element={<ProtectedRoute requiredPermission={{ section: 'trucks', keys: ['trucks_view','trucks_edit'] }}>  <Trucks /> </ProtectedRoute>} />
            <Route path="/siteusers" element={<ProtectedRoute requiredPermission={{ section: 'site users', keys: ['siteusers_view', 'siteusers_edit'] }}> <SiteUsers /> </ProtectedRoute>} />
            <Route path="/notes" element={<ProtectedRoute requiredPermission={{ section: 'notes', keys: ['notes_view'] }}>  <Notes /> </ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute requiredPermission={{ section: 'notifications', keys: ['notifications_view', 'notifications_manage'] }}> <Notifications /> </ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute requiredPermission={{ section: 'settings', keys: ['settings_view', 'settings_edit'] }}> <Settings /> </ProtectedRoute>} />
          </Routes>
        )}
      </div>
    </div>
  );
};

export default TCRoutes;
